import { RouteType } from "types/RouteType";
import { castStoneRoutes } from "@intrasync/cast-stone";

/**
 * Routes from `@intrasync/cast-stone` (currently just the Cast Stone Designer
 * at /cast-stone-designer, sidebar group "Estimating"). The route is fully
 * self-contained: its own `beforeEnter` calls the package's
 * `initializeCastStoneData` (settings → reference data → project list → job
 * from query params) and returns a boolean, per host routing rules.
 *
 * The cast bridges the package's structurally-compatible RouteType (from its
 * own @intrasync/stores copy) to the host's RouteType — same pattern as the
 * other wired @intrasync modules.
 */
const castStoneRoutesList: RouteType[] = castStoneRoutes as unknown as RouteType[];

export default castStoneRoutesList;
